import RegroupementSitesController from './regroupement.sites.controller';
import Template from './regroupement.sites.html';
export default {
	controller: RegroupementSitesController,
	template: Template
};
